import { PUBLISH_STATUS } from 'appConstants';

import {
  FAILED_ORDERS_LOADED,
  FAILED_ORDERS_SYNC_ERROR,
  FAILED_ORDER_REMOVED,
  FAILED_ORDER_REMOVE_ERROR,
  LOAD_FAILED_ORDERS,
  REMOVE_FAILED_ORDER,
  RESET_FAILED_ORDERS,
  SYNC_RESENDED_ORDER,
} from './actionTypes';
import type { IEnvCropsFailedOrdersState } from './types';

export const initialState: IEnvCropsFailedOrdersState = {
  failedOrders: [],
  loaded: false,
  loading: false,
  error: null,
  removing: false,
  removed: false,
  removeError: null,
};

export const reducer = (
  state: IEnvCropsFailedOrdersState = initialState,
  action: { type: string; payload?: any },
): IEnvCropsFailedOrdersState => {
  switch (action.type) {
    case LOAD_FAILED_ORDERS:
      return { ...state, loading: true, loaded: false, error: null };
    case REMOVE_FAILED_ORDER:
      return { ...state, removing: true, removed: false, removeError: null };
    case FAILED_ORDERS_LOADED:
      return { ...state, loading: false, error: null, loaded: true, failedOrders: action.payload };
    case FAILED_ORDER_REMOVED:
      return {
        ...state,
        removing: false,
        removed: true,
        removeError: null,
        failedOrders: state.failedOrders.filter(
          (failedOrder) => failedOrder.internalOrderId !== action.payload,
        ),
      };
    case FAILED_ORDERS_SYNC_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        loaded: false,
      };
    case SYNC_RESENDED_ORDER: {
      let currFailedOrders = state.failedOrders.map((failedOrder) =>
        failedOrder.internalOrderId === action.payload.internalOrderId
          ? action.payload
          : failedOrder,
      );
      // If we have items with status of 'sent', we would like to remove them from the failedOrders Array
      if (action.payload.publishStatus === PUBLISH_STATUS.SENT) {
        currFailedOrders = currFailedOrders.filter(
          (order) => order.internalOrderId !== action.payload.internalOrderId,
        );
      }
      return {
        ...state,
        failedOrders: currFailedOrders,
      };
    }
    case FAILED_ORDER_REMOVE_ERROR:
      return {
        ...state,
        removing: false,
        removeError: action.payload,
        removed: false,
      };
    case RESET_FAILED_ORDERS:
      return {
        ...state,
        failedOrders: [],
        loaded: false,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
